import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TeamMembersAuditInfo } from '@shared/models';

export const TeamMembersActions = createActionGroup({
  source: 'Team Member Actions',
  events: {
    'Load Team Members': props<{ ids: string[]; businessAccountId: string }>(),
    'Load Team Members Success': props<{ teamMembers: TeamMembersAuditInfo }>(),
    'Load Team Members Failure': props<{ error: string }>(),
    'No Team Members To Load': emptyProps,
  },
});
